import {
  doc,
  getDoc,
  serverTimestamp,
  setDoc,
  Timestamp,
} from "firebase/firestore";
import { firestore } from "./firebaseClient";
import {
  GLOBAL_LEGACY_BRIDGE_DOC_ID,
  GLOBAL_SETTINGS_COLLECTION,
  type LegacyBridgeGlobalSettings,
} from "../models/legacyBridge";

const mapTimestamp = (value: unknown): Date | null => {
  if (value instanceof Timestamp) {
    return value.toDate();
  }
  return null;
};

const ref = () =>
  doc(firestore, GLOBAL_SETTINGS_COLLECTION, GLOBAL_LEGACY_BRIDGE_DOC_ID);

export const getLegacyBridgeGlobalSettings =
  async (): Promise<LegacyBridgeGlobalSettings> => {
    const snap = await getDoc(ref());
    if (!snap.exists()) {
      return { minBridgeVersion: "" };
    }
    const data = snap.data() as Record<string, unknown>;
    return {
      minBridgeVersion:
        typeof data.minBridgeVersion === "string" ? data.minBridgeVersion : "",
      updatedAt: mapTimestamp(data.updatedAt),
      updatedBy:
        typeof data.updatedBy === "string" ? data.updatedBy : undefined,
    };
  };

export const upsertLegacyBridgeGlobalSettings = async (input: {
  minBridgeVersion: string;
  updatedBy: string;
}): Promise<void> => {
  await setDoc(
    ref(),
    {
      minBridgeVersion: input.minBridgeVersion.trim(),
      updatedAt: serverTimestamp(),
      updatedBy: input.updatedBy,
    },
    { merge: true }
  );
};

/** Accepts empty string, or major.minor.patch with optional prerelease suffix. */
export const isPlausibleBridgeVersionString = (raw: string): boolean => {
  const s = raw.trim();
  if (!s) {
    return true;
  }
  return /^\d+\.\d+\.\d+([.-][0-9A-Za-z.-]*)?$/.test(s);
};
